import {API} from "../../axios/axiosMainUrl";

const prefix = '/delivery/scales-data'

export const orderScales = {
  state: {
    orderScales: [],
    orderScalesItem: {},
    orderScalesCommonList: [],
    orderScalesBtn: false,
    orderScalesLoading: true,
    nextOrderScalesPage: false,
    orderScalesForPage: 25,
    orderScalesFilter: '',

    orderScalesSocket: false,
    orderScalesSocketChannel: 'private-scale-data-processing-channel.1',
    orderScalesSocketEvent: 'scale-data.transfer',
  },

  mutations: {
    setOrderScalesFilter: (state, payload) => {
      state.orderScalesFilter = payload
    },

    setOrderScales: (state, payload) => {
      if(state.nextOrderScalesPage) {
        console.log(payload.orderScales);
        state.orderScales = state.orderScales.concat(payload.orderScales)
      } else {
        state.orderScales = payload.orderScales
      }
    },

    setOrderScalesCommonList: (state, payload) => {
      state.orderScalesCommonList = payload.orderScalesCommonList
    },

    setNextOrderScalesPage: (state, payload) => {
      state.nextOrderScalesPage = payload
    },

    setOrderScalesItem: (state, payload) => {
      state.orderScalesItem = payload.orderScalesItem
    },

    setOrderScalesLoadingStart: (state) => {
      state.orderScalesLoading = true
    },

    setOrderScalesLoadingEnd: (state) => {
      state.orderScalesLoading = false
    },

    changeOrderScalesBtn: (state) => {
      state.orderScalesBtn = true
    },
    successOrderScalesBtn: (state) => {
      state.orderScalesBtn = false
    },

    setOrderScalesSocket: (state, payload) => {
      state.orderScalesSocket = payload
    },
  },

  getters: {
    getOrderScalesFilter: state => {
      return state.orderScalesFilter
    },

    getOrderScalesForPage: state => {
      return state.orderScalesForPage
    },

    getOrderScales: state => {
      return state.orderScales
    },

    getOrderScalesLoading: state => {
      return state.orderScalesLoading
    },


    getNextOrderScalesPage: state => {
      return state.nextOrderScalesPage
    },

    getOrderScalesItem: state => {
      return state.orderScalesItem
    },

    getOrderScalesCommonList: state => {
      return state.orderScalesCommonList
    },

    getOrderScalesBtn: state => {
      return state.orderScalesBtn
    },

    getOrderScalesSocket: state => {
      return state.orderScalesSocket
    },

    getOrderScalesSocketChannel: state => {
      return state.orderScalesSocketChannel
    },

    getOrderScalesSocketEvent: state => {
      return state.orderScalesSocketEvent
    },
  },

  actions: {

    async fetchOrderScales({commit, getters}, filter = '') {
      if(!getters.getNextOrderScalesPage)
        commit('setOrderScalesLoadingStart')
      try {
        return await API.get(`${prefix}${filter}`).then((response) =>{
          commit('setOrderScales',{orderScales: response.data.data.data})
          // commit('setOrderScalesCommonList',{orderScalesCommonList: response.data.data})
          commit('setOrderScalesCommonList',{orderScalesCommonList: {...response.data.data.meta, ...{
                next_page_url: response.data.data.links.next,
                first_page_url: response.data.data.links.first,
                last_page_url: response.data.data.links.last,
                prev_page_url: response.data.data.links.prev
              }}})
          commit('setOrderScalesLoadingEnd');
          return response;
        });
      } catch (e) {
        commit('setOrderScalesLoadingEnd');
        return e;
      }
    },

    async getOrderScales({commit}, id) {
      commit('setOrderScalesLoadingStart');
      try {
        return await API.get(`${prefix}/${id}`).then((response) =>{
          commit('setOrderScalesItem', {orderScalesItem: response.data.data})
          commit('setOrderScalesLoadingEnd');
          return response;
        });
      } catch (e) {
        commit('setOrderScalesLoadingEnd');
        return e;
      }
    },

    async createOrderScales({commit}, data) {
      commit('changeOrderScalesBtn');
      try {
        return await API.post(`${prefix}`, data).then((response) =>{
          commit('successOrderScalesBtn');
          return response;
        });
      } catch (e) {
        commit('successOrderScalesBtn');
        return e;
      }
    },

    async updateOrderScales({commit}, {id}) {
      commit('changeOrderScalesBtn');
      try {
        return await API.put(`${prefix}/${id}/order-edit`).then((response) =>{
          commit('successOrderScalesBtn');
          return response;
        });
      } catch (e) {
        commit('successOrderScalesBtn');
        return e;
      }
    },

    async deleteOrderScales({commit}, id) {
      try {
        return await API.delete(`${prefix}/${id}`).then((response) =>{
          return response;
        });
      } catch (e) {
        commit('successOrderScalesBtn');
        return e;
      }
    },

  }
}
